<style scoped lang="scss">
.container {
    width: 100vw;
    height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: 
            radial-gradient(circle at 20% 20%, rgba(79, 70, 229, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(124, 58, 237, 0.05) 0%, transparent 50%);
        z-index: 0;
    }
}

.content-div {
    background: rgba(255, 255, 255, 0.95);
    padding: 2rem;
    position: relative;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.8);
    z-index: 1;
}

.content-header {
    position: absolute;
    left: 1.5rem;
    top: 1.5rem;
    font-size: 1rem;
    color: #4f46e5;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s ease;
    
    &:hover {
        color: #7c3aed;
        transform: translateX(-2px);
    }
}

.decription {
    padding: 1rem;
    font-size: 0.95rem;
    line-height: 1.6;
    color: #4a5568;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    
    strong {
        color: #4f46e5;
        font-weight: 600;
    }
}

:deep(.el-tabs) {
    .el-tabs__header {
        margin-bottom: 2rem;
    }
    
    .el-tabs__item {
        font-size: 1rem;
        padding: 0 1.5rem;
        height: 3rem;
        line-height: 3rem;
        
        &.is-active {
            color: #4f46e5;
            font-weight: 500;
        }
    }
    
    .el-tabs__active-bar {
        background-color: #4f46e5;
        height: 3px;
    }
}

:deep(.el-input) {
    .el-input__wrapper {
        padding: 0.5rem 1rem;
        border-radius: 6px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        transition: all 0.2s ease;
        
        &:hover {
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        // &.is-focus {
        //     box-shadow: 0 0 0 2px rgba(13, 0, 255, 0.2);
        // }
    }
}

:deep(.el-button) {
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.2s ease;
    
    &.is-success {
        background: #4f46e5;
        border-color: #4f46e5;
        
        &:hover {
            background: #4338ca;
            border-color: #4338ca;
            transform: translateY(-1px);
        }
    }
}

// pc端
@media screen and (min-width: 768px) {
    .content-div {
        width: 35rem;
    }
}

//移动端
@media screen and (max-width: 769px) {
    .content-div {
        width: 90%;
        padding: 1.5rem;
    }
    
    .content-header {
        left: 1rem;
        top: 1rem;
    }
    
    :deep(.el-tabs) {
        .el-tabs__item {
            font-size: 0.9rem;
            padding: 0 1rem;
        }
    }
    
    :deep(.el-input) {
        width: 100% !important;
    }
}
</style>
<template>
    <div class="container" :style="bgStyle">
        <IndexHeader />
        <div class="content-div">
            <el-tabs v-model="el_tab_active" class="demo-tabs" @tab-click="handleClick">
                <el-tab-pane label="使用卡密" name="first">
                    <div>
                        <el-input v-model="form.kami" placeholder="请输入卡密" class="mt-3" style="width: 20rem;"></el-input>
                        <el-input v-model="form.host" placeholder="授权字段(ip/域名等)" class="mt-3"
                            style="width: 20rem;"></el-input>
                        <el-input v-model="form.email" placeholder="绑定邮箱" class="mt-3" style="width: 20rem;"></el-input>
                        <el-card class="box-card decription mt-3">
                            <div>
                                <strong>授权字段：</strong>不同插件要求的授权字段是不一样的，可能要求授权域名，可能要求授权ip，也可能要求授权手机号等等
                                <br><strong>绑定邮箱：</strong>授权将会绑定到此邮箱上面，若邮箱未注册易售SUP授权站则会自动注册，默认密码123456，将会自动绑定上级用户为卡密的创建者
                            </div>
                        </el-card>
                        <el-button type="success" class="mt-4 mb-5" @click="useCarmine()">使用卡密</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="验证卡密" name="second">
                    <div style="font-size :1rem;">
                        <el-input v-model="form.kami" placeholder="请输入卡密" class="mt-3" style="width: 20rem;"></el-input>
                        <div v-if="form.isVerify" class="mt-2">
                            <div> <span>卡密：</span><span>{{ showCarmine.carmine }}</span> </div>
                            <div> <span>状态：</span><span :style="{
                                'color': showCarmine.state == 1 ? 'green' : 'red'
                            }">{{ getCarmineSate(showCarmine.state) }}</span> </div>
                            <div> <span>类型：</span><span>{{ getCarmineType(showCarmine.timeUnit) }}</span> </div>
                            <div v-if="showCarmine.state == 1">
                                <span>创建者：</span><span>{{ showCarmine.createUid }}</span>
                            </div>
                            <div v-else>
                                <span>使用者：</span><span>{{ showCarmine.usedUid }}</span>
                            </div>
                            <div> <span>插件：</span><span class="text-warning">{{ showCarmine.pluginName }}</span> </div>
                            <div> <span>功能版本：</span><span class="text-primary">{{ showCarmine.versionName }}</span> </div>
                        </div>
                        <el-card v-else class="box-card decription mt-3">
                            <div>
                               本功能是用于查询卡密状态，查询是否被使用等！不会影响卡密有效性，请放心查询
                            </div>
                        </el-card>
                        <div>
                            <el-button type="success" class="addEmpower-btn  mt-4 mb-5 ml-5"
                                @click="verifyCarmine()">查询卡密</el-button>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <IndexFooter />
    </div>

</template>
<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus'
import IndexHeader from '@/components/IndexHeader.vue'
import IndexFooter from '@/components/IndexFooter.vue'
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    name: 'CarmineUse',
    components: {
        IndexHeader,
        IndexFooter
    },
    data() {
        return {
            form: {
                host: "",
                kami: "",
                email: "",
                isVerify: false
            },
            showCarmine: {
            },
            includes_data: [],
            form_position: "top",
            bgImageUrl: [
                require('@/assets/img/bg2.webp'),
                require('@/assets/img/bg3.jpg'),
                require('@/assets/img/bg4.png'),
                require('@/assets/img/bg5.png'),
                require('@/assets/img/bg6.webp'),
                require('@/assets/img/bg7.webp'),
                require('@/assets/img/bg8.webp'),
                require('@/assets/img/bg9.webp'),
            ],
            el_tab_active: "first"
        }
    },
    computed: {
        bgStyle() {
            let i = Math.floor(Math.random() * this.bgImageUrl.length);
            return {
                // 'background': `url(${this.bgImageUrl[i]})`
            };
        }
    },
    methods: {
        handleClick(tab) {
            this.form.isVerify = false
            this.el_tab_active = tab
        }, useCarmine() {
            axios.post(baseURL + "/carmine/use", {
                carmine: this.form.kami,
                host: this.form.host,
                email: this.form.email
            }, {
                timeout: 30000,
                headers: {
                    'token': localStorage.getItem("token")
                }
            }).then(res => {
                if (res.data.code == 200) {
                    ElMessage.success(res.data.msg)
                } else {
                    ElMessage.error(res.data.msg)
                }
            }).catch(err => {
                ElMessage.error('请求失败：' + err.message)
                console.log(err)
            })
        },
        verifyCarmine() {
            axios.get(baseURL + "/carmine/verify?kami=" + this.form.kami, {
                timeout: 30000,
            }).then(res => {
                if (res.data.code == 200) {
                    ElMessage.success(res.data.msg)
                    this.showCarmine = res.data.data.kami
                    this.form.isVerify = true
                } else {
                    ElMessage.error(res.data.msg)
                }
            }).catch(err => {
                ElMessage.error('请求失败：' + err.message)
                console.log(err)
            })
        },
        getCarmineSate(state) {
            if (state == 1) {
                return "未使用"
            } else if (state == 0) {
                return "已被使用"
            } else if (state == -1) {
                return "已被禁用"
            }
        },
        getCarmineType(type) {
            if (type == "day") {
                return "天"
            } else if (type == "month") {
                return "月"
            } else if (type == "year") {
                return "年"

            } else if (type == "forever") {
                return "永久"
            }
            else {
                return "未知"
            }
        }
    }
})
</script>